import React, { useState } from "react";
import "./novel-object-video-stats.css";

function NovelObjectVideoStats(props) {
  const [activityData, setActivityData] = useState({
    leftTime: 0,
    leftCount: 0,
    rightTime: 0,
    rightCount: 0,
    totalTime: 0,
    timePassed: 0,
  });

  if (props.props != null) props.props.SetDataUpdateCallback(setActivityData);

  return (
    <>
      <div className="flex-row">
        <div>Time Elapsed</div>
        <div className="mono-spaced">{(activityData.timePassed / 1000).toFixed(3)}s</div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Object</th>
            <th># Times Visited</th>
            <th>Time at Object</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Left</td>
            <td>{activityData.leftCount}</td>
            <td className="mono-spaced">{(activityData.leftTime / 1000).toFixed(3)}s</td>
          </tr>
          <tr>
            <td>Right</td>
            <td>{activityData.rightCount}</td>
            <td className="mono-spaced">{(activityData.rightTime / 1000).toFixed(3)}s</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td>{activityData.leftCount + activityData.rightCount}</td>
            <td className="mono-spaced">{(activityData.totalTime / 1000).toFixed(3)}s</td>
          </tr>
        </tfoot>
      </table>
    </>
  );
}

export default NovelObjectVideoStats;
